import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ConstructionIcon from '@mui/icons-material/Construction';

const Home = () => {
    return (
        <Card sx={{
            mt: 10,
            minWidth: "25%",
            minHeight: "25vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <CardContent>
                <ConstructionIcon color="info" sx={{ fontSize: 40 }} />
                <Typography sx={{ mt: 1.5, fontSize: 24 }} color="text.primary">
                    Development in progress...
                </Typography>
            </CardContent>
        </Card>
    )
};

export default Home;
